<div fxLayout="column" fxLayoutAlign="center center">
  <div class="main-container" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">
    <div class="avatar-container">
      <lineup-avatar [image]="image" [darkened]="shouldShowIcons" [thumbnail]="false"></lineup-avatar>
    </div>
    <button class="icon-container upload" (click)="fileInput.click()" *ngIf="shouldShowUploadPhoto()">
      <mat-icon class="file-upload">insert_photo</mat-icon><br />
      <span
        ><b>Upload<br />Photo</b></span
      >
    </button>
    <button
      mat-mini-fab
      color="warn"
      aria-label="Delete photo"
      class="icon-container delete"
      (click)="removePicture()"
      *ngIf="shouldShowRemoveIcon()"
    >
      <mat-icon class="file-remove">delete</mat-icon>
    </button>
  </div>
  <input
    type="file"
    id="fileupload"
    #fileInput
    ng2FileSelect
    [uploader]="uploader"
    (change)="fileInput.value = ''"
    accept="image/jpeg,image/jpg,image/png,image/x-png"
  />
</div>
